export interface ILichSuDangNhap{
    Id: number,
    TaiKhoan: string,
    HoTen: string,
    DienThoai: string,
    IdNguoiDung: string,
    ThoiGian: string,
    Ip: string,
    HeDieuHanh: string,
    TrinhDuyet: string,
    TenDonVi:string,
    TenCoQuan:string,
}
export class LichSuDangNhap implements ILichSuDangNhap{
    Id: number = 0 ;
    TaiKhoan: string='';
    HoTen: string='';
    DienThoai: string='';
    IdNguoiDung: string='';
    ThoiGian: string='';
    Ip: string='';
    HeDieuHanh: string='';
    TrinhDuyet: string='';
    TenDonVi:string='';
    TenCoQuan:string='';
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/he-thong/lich-su-dang-nhap/lich-su-dang-nhap.ts